<template>
  <div class="addcomment" v-if="seen">
    <div class="commentbox">
      <div class="close">
        <span class="success" v-if="success"> Comment saved... </span>
        <span class="close-box" @click="close">
          <svg style="width: 18px; height: 18px" viewBox="0 0 24 24">
            <path
              fill="#FC6D6C"
              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            />
          </svg>
        </span>
      </div>
      <div class="name">
        <strong>{{ str_text(name) }}</strong>
      </div>
      <div class="box">
        <div class="top">
          <div class="textfield">
            <div
              class="comment"
              :class="{ error: error }"
              ref="comments"
              contenteditable="true"
              :placeholder="comment.comment"
              @focus="fint"
            ></div>
            <div class="send" @click="sendcomment">
              <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                <path fill="#ccc" d="M2,21L23,12L2,3V10L17,12L2,14V21Z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.name {
  text-align: left;
}
</style>

<script>
import { setTimeout } from "timers";
import { mapMutations } from "vuex";
import moment from "moment";
import cookies from "@/services/cookies";

export default {
  data() {
    return {
      seen: false,
      name: "",
      id: "",
      comment: "",
      error: false,
      loader: false,
      success: false,
      fint_text: true,
      base: false,
    };
  },
  methods: {
    ...mapMutations([
      "UPDATE_PREVIEW_COMMENT",
      "UPDATE_TOTAL_COMMENT",
      "UPDATE_COMMENTS",
      "UPDATE_COMMENTS_LIST",
      "EMPTY_FILE_ACTION",
    ]),
    timeAgo(time) {
      return moment(time).fromNow(); // 8 years ago
    },
    fint(evt) {
      this.error = false;
    },
    str_text(str) {
      return str.length > 38 ? str.substr(0, 38) + "..." : str;
    },
    logincall() {
      this.$parent.logincall();
    },
    async load(name, data, base = false) {
      this.loader = false;
      this.comment_id = data._id;
      this.name = name;
      this.seen = true;
      this.comment = data.comment;
      //this.$refs.comments.innerText = data

      // if (this.id != '') {
      //   let that = this
      //   this.loader = true
      //   let data = {
      //     token: cookies.getCookie('token'),
      //     id: this.id,
      //     limit: false
      //   }

      //   // this.$socket.emit('get-comments', data, function (data) {
      //   //   if (data.data === true) {
      //   //     that.loader = false
      //   //     that.UPDATE_COMMENTS(data.comments)
      //   //   }

      //   //   if (data.data === false) {
      //   //     that.seen = false
      //   //     that.logincall()
      //   //   }
      //   // })
      // }
    },
    sendcomment() {
      if (this.$refs.comments.innerText === "") {
        this.error = true;
      } else {
        this.loader = true;
        let that = this;

        let data = {
          token: cookies.getCookie("token"),
          comment_id: this.comment_id,
          comment: this.$refs.comments.innerText,
          limit: true,
        };

        this.$socket.emit("editcomment", data, function (data) {
          if (data.message === "completed") {
            that.$refs.comments.innerText = "";
            that.loader = false;
            that.success = true;
            that.comment = "";
            that.UPDATE_COMMENTS_LIST(data.comments[0]);
            that.UPDATE_PREVIEW_COMMENT(data.comments);
            that.UPDATE_TOTAL_COMMENT(data.comments_total);

            setTimeout(() => {
              that.success = false;
            }, 3000);
          }

          if (data.data === false) {
            that.seen = false;
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    close() {
      this.seen = false;
      this.comment = "";
      this.loader = false;
    },
  },
};
</script>
